import { Button } from "@volca/ui/components/ui/button";
import { Stack } from "@volca/ui/components/ui/stack";
import { ReferralList } from "@/business-settings/common/referral-list";
import { SignupSourceCodeInfo } from "@/business-settings/common/signup-source-code-info";
import type { SignupSource } from "@/referral-sources/referral-source";
import { useGetRepAssignedReferrals } from "@/referrals/query";
import type { DetailedUser } from "@/user/user";

export const UserReferralDetails = ({
  user,
  open,
  onOpenChange,
}: {
  user: DetailedUser;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) => {
  const referrals = useGetRepAssignedReferrals(user.id);
  return (
    <Stack gap={4} className="w-full">
      <Button variant="ghost" size="sm" onClick={() => onOpenChange(!open)}>
        {open ? "Hide referral details" : "Show referral details"}
      </Button>
      <Stack hidden={!open} className="w-full">
        <SignupSourceCodeInfo signupSource={user as SignupSource} />
        <ReferralList
          referrals={referrals.data ?? []}
          isLoading={referrals.isLoading}
        />
      </Stack>
    </Stack>
  );
};
